// Map ISO 639-1 / locale codes used in LANGUAGES_CONFIG to a flag emoji.
// Region-tagged locales (pt_BR, zh_TW, zh_CN) use their region flag.
const LANGUAGE_FLAGS = {
  en: '🇬🇧',
  ar: '🇸🇦',
  nl: '🇳🇱',
  fr: '🇫🇷',
  de: '🇩🇪',
  hi: '🇮🇳',
  it: '🇮🇹',
  ja: '🇯🇵',
  ko: '🇰🇷',
  pt: '🇵🇹',
  ru: '🇷🇺',
  zh: '🇨🇳',
  es: '🇪🇸',
  ml: '🇮🇳',
  ca: '🇪🇸',
  el: '🇬🇷',
  pt_BR: '🇧🇷',
  ro: '🇷🇴',
  ta: '🇮🇳',
  fa: '🇮🇷',
  zh_TW: '🇹🇼',
  vi: '🇻🇳',
  da: '🇩🇰',
  tr: '🇹🇷',
  cs: '🇨🇿',
  fi: '🇫🇮',
  id: '🇮🇩',
  sv: '🇸🇪',
  hu: '🇭🇺',
  no: '🇳🇴',
  zh_CN: '🇨🇳',
  pl: '🇵🇱',
  sk: '🇸🇰',
  uk: '🇺🇦',
  th: '🇹🇭',
  lv: '🇱🇻',
  is: '🇮🇸',
  he: '🇮🇱',
  lt: '🇱🇹',
  sr: '🇷🇸',
  bg: '🇧🇬',
  et: '🇪🇪',
};

export const getLanguageFlag = code => LANGUAGE_FLAGS[code] || '🌐';

export const getLanguageDisplayName = (code, name) =>
  `${getLanguageFlag(code)}  ${name}`;
